import React from 'react';
import { Card } from '@mui/material';

import CheckoutPageHeader from '../components/checkout/CheckoutPageHeader';
import { paths } from '../config/paths';
import PageContainer from './PageContainer';

export default function LegalPageLayout({ title, children }) {
  return (
    <PageContainer sx={{ px: { xs: 1.5, sm: 2 }, pb: 4, maxWidth: { xs: 720, md: 800 } }}>
      <CheckoutPageHeader backTo={paths.home} title={title} />
      <Card
        elevation={0}
        sx={{
          p: { xs: 2, md: 2.5 },
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          bgcolor: 'background.paper',
        }}
      >
        {children}
      </Card>
    </PageContainer>
  );
}
